<template>
   <div>
      <div v-if="ideas.length < 1" class="mt-4 text-center">
         Keine Ideen vorhanden.
      </div>
      <div v-for="(idea, index) in ideas" :key="index" class="mt-4" :id="idea.id">
         <router-link :to="{ name: 'IdeasWorkbenchIdeasShow', params: { id: idea.id}}" class="custom-link"
                      style="height: 100%;">
            <v-hover v-slot:default="{ hover }">
               <v-card outlined style="height: 100%;" :elevation="hover ? 8 : 0">
                  <v-system-bar style="height: auto;" color="#f5f5f5" class="px-4">
                     {{ idea.creator_last_name }}, {{ idea.creator_first_name }} &nbsp;<span class="mx-1"
                                                                                             v-if="idea.creator_orga_unit">({{
                        idea.creator_orga_unit
                     }})</span>
                     am {{ idea.created_at }}
                     <v-chip class="ml-1" v-if="idea.is_new" color="primary" small>Neu</v-chip>
                     <v-spacer/>
                     <v-tooltip bottom v-if="!idea.is_subscribed">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click.prevent="subscribeFeed(idea.id)"
                           >
                              <v-icon color="primary" class="ma-0">mdi-bell-outline</v-icon>
                           </v-btn>
                        </template>
                        <span>Benachrichtigungen erhalten</span>
                     </v-tooltip>
                     <v-tooltip bottom v-if="idea.is_subscribed">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click.prevent="unsubscribeFeed(idea.feed_id)"
                           >
                              <v-icon color="primary" class="ma-0">mdi-bell</v-icon>
                           </v-btn>
                        </template>
                        <span>Benachrichtigungen abstellen</span>
                     </v-tooltip>
                  </v-system-bar>
                  <v-card-title class="subtitle-1">
                     {{ idea.title }}
                  </v-card-title>
                  <v-card-subtitle>
                     <div class="d-flex justify-space-between">
                        <div>
                           <v-chip small label :outlined="idea.current_state.name === 'open'"
                                   :color="getStateColor(idea.current_state.name)">
                              <v-avatar left>
                                 <v-icon small>{{getStateIcon(idea.current_state.name)}}</v-icon>
                              </v-avatar>
                              {{ idea.current_state.name_de }}
                           </v-chip>
                           <span v-if="idea.current_state.name !== 'open'"> am {{
                                 idea.current_state.created_at
                              }}</span>
                        </div>
                     </div>
                     <div v-if="idea.current_state.comment">
                        {{ idea.current_state.comment }}
                     </div>
                  </v-card-subtitle>
                  <v-card-text class="black--text" v-html="idea.description"/>
                  <v-card-text v-if="idea.is_voting">
                     <v-btn outlined class="mr-1" style="pointer-events: none;">{{ idea.votes }}</v-btn>
                     <v-btn :color="color(idea.was_voted, true)" outlined class="mr-1"
                            @click.prevent="vote(1, idea.id)">Up
                        <v-icon>mdi-chevron-up</v-icon>
                     </v-btn>
                     <v-btn :color="color(idea.was_voted)" outlined class="mr-1"
                            @click.prevent="vote(-1, idea.id)">Down
                        <v-icon>mdi-chevron-down</v-icon>
                     </v-btn>
                  </v-card-text>
               </v-card>
            </v-hover>
         </router-link>
      </div>
   </div>
</template>

<script>
export default {
   props: ['ideas'],
   name: "",
   data: () => ({}),
   created() {
   },
   methods: {
      getStateColor(state) {
         switch (state) {
            case 'open':
               return 'success';
            case 'review':
               return 'info';
            case 'declined':
               return 'warning';
            case 'accepted':
               return 'success';
            case 'realized':
               return 'success darken-1';
            case 'closed':
               return 'error';
         }
      },
      getStateIcon(state){
         switch (state) {
            case 'open':
               return 'mdi-checkbox-blank-circle-outline';
            case 'review':
               return 'mdi-clock-outline';
            case 'declined':
               return 'mdi-close-circle-outline';
            case 'accepted':
               return 'mdi-arrow-top-right-thin-circle-outline';
            case 'realized':
               return 'mdi-check-circle-outline';
            case 'closed':
               return 'mdi-checkbox-blank-circle';
         }
      },
      subscribeFeed(id) {
         var data = {};
         data.feedable_type = 'idea';
         data.feedable_id = id;

         this.axios.post('/feeds', {
            'feed': data
         }).then(() => {
            this.$toast.success('Sie erhalten nun Benachrichtigungen der Idee.');
            this.getCategory();
         })
      },
      unsubscribeFeed(id) {
         this.axios.delete('/feeds/' + id).then(() => {
            this.$toast.success('Sie erhalten nun keine Benachrichtigungen der mehr.');
            this.getCategory();
         })
      },

      vote(value, id) {
         this.axios.post('/ideas/' + id + '/vote', {
            'value': value
         }).then(() => {
            this.$toast.success('Der Vote wurde erfolgreich platziert.');
            this.getCategory();
         }).catch((e) => {
            console.log(e);
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      },
      color(vote, positive) {
         if (vote === 1 && positive) {
            return 'green darken-2';
         } else if (vote === -1 && !positive) {
            return 'red';
         } else {
            return 'grey lighten-1';
         }
      }
   },
}
</script>

<style scoped>

</style>
